import { Link } from 'react-router-dom';
import {
  Paper,
  Stack,
  Group,
  Title,
  Button,
  Text,
  Skeleton,
  Center,
} from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import {
  useMessageTemplateList,
  MessageTemplatesParams,
} from '#/components/ui/messages/endpoints';
import { MessageTemplateList } from '#/components/ui/messages/MessageTemplateList';

import {
  MessageTemplateSearchBar,
  useMessageTemplateSearchBarParams,
} from '#/components/ui/messages/MessageTemplateList/MessageTemplateSearchBar';
import { useState } from 'react';

const MessageListPage = () => {
  const [currentPage, setPage] = useState<MessageTemplatesParams['page']>(1);
  const { params } = useMessageTemplateSearchBarParams();

  const PAGE_SIZE = 10;

  const { data, isLoading, isFetching, refetch } = useMessageTemplateList(
    params,
    {
      page: currentPage - 1,
      pageSize: PAGE_SIZE,
    },
  );

  const records = data?.items ?? [];

  const content = (() => {
    if (isLoading) {
      return (
        <Stack py={30} gap={20}>
          <Skeleton height={20} radius="xl" />
          <Skeleton height={20} width="70%" radius="xl" />
          <Skeleton height={20} radius="xl" />
          <Skeleton height={20} width="70%" radius="xl" />
          <Skeleton height={20} radius="xl" />
          <Skeleton height={20} width="70%" radius="xl" />
          <Skeleton height={20} radius="xl" />
          <Skeleton height={20} width="70%" radius="xl" />
        </Stack>
      );
    }

    if (!data) {
      return (
        <>
          <Center h="100%">
            <Stack>
              <Text>有東西出錯拉！</Text>
              <Button
                onClick={() => {
                  refetch();
                }}
              >
                重新整理
              </Button>
            </Stack>
          </Center>
        </>
      );
    }
    const paging = data?.paging;

    return (
      <>
        <MessageTemplateSearchBar />
        <MessageTemplateList
          records={records}
          recordsPerPage={paging.pageSize}
          totalRecords={paging.totalCount}
          onPageChange={setPage}
          page={currentPage}
          fetching={isFetching}
          total={paging.totalPages}
        />
      </>
    );
  })();

  return (
    <Paper radius="lg" p="xl" shadow="xl" style={{ flex: 1 }} display="flex">
      <Stack gap="md" display="flex" style={{ flex: 1 }}>
        <Group justify="space-between">
          <Title order={2}>訊息排程</Title>
          <Button
            component={Link}
            to="/messages/new"
            leftSection={<IconPlus size={20} />}
          >
            新增訊息
          </Button>
        </Group>
        {content}
      </Stack>
    </Paper>
  );
};

export default MessageListPage;
